export default __webpack_public_path__ + "static/media/taxi.79916ebe.svg";